module.exports = __webpack_public_path__ + "img/shidu1.gif";